import MainLayout from 'layouts/MainLayout';
import PublicThemeProvider from 'pages/onboarding/components/PublicThemeProvider';
import { ReactNode } from 'react';
import { Box } from '@mui/material';

interface AuthLayoutProps {
  children: ReactNode;
  skipMe?: boolean;
}

const AuthPageContainer = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      width: '100%',
      maxWidth: 'none',
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      minHeight: '100%',
    }}>
    {children}
  </Box>
);

const AuthLayout = ({ children, skipMe = false }: AuthLayoutProps) => {
  return (
    <PublicThemeProvider>
      <MainLayout
        sx={{ p: 0, backgroundColor: 'common.white' }}
        AuthContainer={AuthPageContainer}
        skipMe={skipMe}>
        {children}
      </MainLayout>
    </PublicThemeProvider>
  );
};

export default AuthLayout;
